import { render, staticRenderFns } from "./systemPay.vue?vue&type=template&id=c52e4d2a&scoped=true&"
import script from "./systemPay.vue?vue&type=script&lang=js&"
export * from "./systemPay.vue?vue&type=script&lang=js&"
import style0 from "./systemPay.vue?vue&type=style&index=0&id=c52e4d2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e4d2a",
  null
  
)

export default component.exports